/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TranslationIcon = /*#__PURE__*/ createSvgIcon(
  'TranslationIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M8.22 15l3.147-8.288h1.49L16 15h-1.411l-.774-2.142h-3.413L9.69 15H8.22zm2.656-3.348h2.467l-1.212-3.43h-.045l-1.21 3.43zm-8.61 1.136l-.938-.949 3.547-3.453a19.019 19.019 0 01-1.24-1.4 9.384 9.384 0 01-1.026-1.585h1.493c.23.375.49.728.78 1.058.288.331.57.657.847.98.468-.509.91-1.028 1.324-1.558.414-.53.735-1.112.965-1.744H0V2.85h5.136V1H6.44v1.85h5.136v1.287H9.42a7.824 7.824 0 01-1.153 2.275 22.822 22.822 0 01-1.625 1.974l1.66 1.604-.521 1.334-1.993-1.966-3.523 3.43z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M9.863 19l4.139-10.8h1.865L20 19h-1.858l-.967-2.757h-4.432L11.793 19h-1.93zm3.456-4.343h3.225l-1.587-4.443h-.054l-1.584 4.443zM2.72 16.3L1.411 15l4.593-4.557a13.996 13.996 0 01-1.49-1.937c-.428-.673-.8-1.375-1.116-2.106h1.87c.28.533.57 1.011.874 1.434.302.423.67.878 1.1 1.366a13.319 13.319 0 001.694-2.215c.446-.742.807-1.537 1.086-2.385H0V2.8h6.35V1h1.814v1.8h6.35v1.8h-2.675a16.998 16.998 0 01-1.284 3.077A14.104 14.104 0 018.553 10.5l2.16 2.186-.691 1.857L7.257 11.8l-4.536 4.5z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M11.832 23l4.946-13.2h2.237L24 23h-2.262l-1.16-3.392h-5.282L14.122 23h-2.29zm4.124-5.322h3.874l-1.906-5.407h-.065l-1.903 5.407zM3.264 19.7l-1.566-1.584 5.531-5.569a18.62 18.62 0 01-1.804-2.377A17.168 17.168 0 014.08 7.6h2.265c.332.645.681 1.229 1.048 1.752.367.523.802 1.075 1.307 1.657.82-.895 1.495-1.794 2.027-2.696A15.55 15.55 0 0012.054 5.4H0V3.2h7.616V1h2.177v2.2h7.616v2.2h-3.175a20.414 20.414 0 01-1.542 3.75 16.942 16.942 0 01-2.427 3.443l2.61 2.701-.82 2.246-3.35-3.34-5.44 5.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TranslationIcon;
